"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepContainer = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Container = _styledComponents.default.div.withConfig({
  componentId: "sc-12a27sm-0"
})(["width:100%;height:2px;", ""], function (_ref) {
  var appearance = _ref.appearance;
  return "".concat(appearance);
});

exports.Container = Container;

var StepContainer = _styledComponents.default.div.withConfig({
  componentId: "sc-12a27sm-1"
})(["", " ", ""], function (_ref2) {
  var barWidth = _ref2.barWidth;
  return "\n    width: ".concat(barWidth, "%;\n    height: 100%;\n  ");
}, function (_ref3) {
  var appearance = _ref3.appearance;
  return "".concat(appearance);
});

exports.StepContainer = StepContainer;